import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/anim";

const POLICIES = [
  "A booking is not confirmed until payment and the rental agreement have been received.",
  "A 50% booking payment is required for most exclusive-space rentals.",
  "Remaining balances are due before the rental period begins.",
  "A refundable security deposit may be required.",
  "Renters are responsible for their own inventory, products, tools, clients, payments, taxes, refunds, licenses, and insurance where applicable.",
  "No permanent alterations, drilling, painting, or damaging adhesives are permitted.",
  "Temporary branding and displays must be approved.",
  "Renters must leave the space clean.",
  "Damage, excessive cleaning, missing fixtures, or missing equipment may be deducted from the security deposit.",
  "No illegal or unauthorized products or services.",
  "Alcohol, prepared food, chemical treatments, regulated products, or services requiring special licenses must receive prior approval.",
];

const BEAUTY_RULES = [
  "Beauty professionals are responsible for maintaining any licenses, permits, professional insurance, or certifications required for their services.",
  "Workstations and tools must be properly cleaned and sanitized.",
  "Professionals should provide their own specialized tools, supplies, and products unless specifically included.",
  "Chemical services, strong fumes, hair coloring, bleaching, acrylic services, or similar activities require prior approval.",
  "Each renter is responsible for their clients, appointments, payments, cancellations, and customer disputes.",
  "Renters are responsible for damage caused by dyes, polish, adhesives, chemicals, hot tools, or equipment.",
];

function NumberedList({ items, base }) {
  return (
    <ol className="mt-12 border-t border-beige/60">
      {items.map((p, i) => (
        <Reveal key={i} delay={i * 0.03}>
          <li className="grid grid-cols-12 gap-4 border-b border-beige/60 py-6">
            <span className="col-span-2 font-serif text-sm italic text-sanddeep sm:col-span-1">
              {String(i + 1).padStart(2, "0")}
            </span>
            <p className="col-span-10 text-sm leading-relaxed text-ink sm:text-base">{p}</p>
          </li>
        </Reveal>
      ))}
    </ol>
  );
}

export default function Rules() {
  return (
    <>
      <PageHero
        eyebrow="Rules & Rental Policies"
        lines={[
          <>Clear terms.</>,
          <>
            <em>Happy renting.</em>
          </>,
        ]}
        sub="A professional space runs on mutual respect. These policies keep Essandtials beautiful, safe, and fair for every renter."
      />

      <section className="bg-paper pb-24 sm:pb-32" data-testid="rules-policies">
        <div className="mx-auto max-w-[1100px] px-6 lg:px-10">
          <Reveal>
            <h2 className="font-serif text-3xl uppercase text-ink sm:text-4xl">
              Rental <em>Policies</em>
            </h2>
          </Reveal>
          <NumberedList items={POLICIES} />

          <Reveal>
            <h2 className="mt-20 font-serif text-3xl uppercase text-ink sm:text-4xl">
              Beauty <em>Rental Rules</em>
            </h2>
          </Reveal>
          <NumberedList items={BEAUTY_RULES} />
        </div>
      </section>
    </>
  );
}
